import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { profileCompletionGuard } from './guards/profile-completion.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'projects',
    loadComponent: () => import('./pages/project-list/project-list.page').then(m => m.ProjectListPage),
    canActivate: [authGuard, profileCompletionGuard]
  },
  {
    path: 'projects/new',
    loadComponent: () => import('./pages/project-new/project-new.page').then(m => m.ProjectNewPage),
    canActivate: [authGuard, profileCompletionGuard]
  },
  {
    path: 'projects/:id',
    loadChildren: () => import('./pages/project-detail/project-detail.module').then(m => m.ProjectDetailPageModule),
    canActivate: [authGuard, profileCompletionGuard]
  },
  {
    path: 'applications',
    loadChildren: () => import('./pages/application-list/application-list.module').then(m => m.ApplicationListPageModule),
    canActivate: [authGuard, profileCompletionGuard]
  },
  {
    path: 'deliveries',
    loadChildren: () => import('./pages/delivery-list/delivery-list.module').then(m => m.DeliveryListPageModule),
    canActivate: [authGuard, profileCompletionGuard]
  },
  {
    path: 'account',
    loadComponent: () => import('./auth/account/account.page').then(m => m.AccountPage),
    canActivate: [authGuard]
  },
  {
    path: 'account/creator-profile',
    loadComponent: () => import('./auth/creator-onboarding/profile-completion.page').then(m => m.ProfileCompletionPage),
    canActivate: [authGuard]
  },
  {
    path: 'accept/:token',
    loadComponent: () => import('./pages/award-acceptance/award-acceptance.page').then(m => m.AwardAcceptancePage),
    canActivate: [authGuard]
  },
  {
    path: '',
    redirectTo: 'projects',
    pathMatch: 'full',
  },
];
